import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Client from './components/Client';
import About from './components/About';
import Contact from './components/Contact';
import Project from './components/Project';
import ProjectClosure from './components/ProjectClosure';
import ProjectMyPortfolio from './components/ProjectMyPortfolio';
import UserGuideDetails from './components/UserGuideDetails';
import ReleaseNotes from './components/ReleaseNotes';
import ReleaseNotesHistory from './components/ReleaseNotesHistory';
import DLScoreCard from './components/DLScoreCard';
import Error from './components/Error';
import ErrorAccess from './components/ErrorAccess';
import ErrorAccessDM from './components/ErrorAccessDM';
import DeliveryMetrics from './components/DeliveryMetrics';
import UploadCenter from './components/UploadCenter';
import Cir from './components/Cir';

const App = () => {

  return (
    <Router>     
      <div className="container">
        <Routes>
          <Route path="/" element={<Client />} />
          <Route path="/client/*" element={<Client />} />
          <Route path="/about" element={<About />} />
          <Route path="/cir/*" element={<Cir />} />
          <Route path="/error" element={<Error />} />
          <Route path="/erroraccess" element={<ErrorAccess />} />
          <Route path="/erroraccessdm" element={<ErrorAccessDM />} />
          <Route path="/userguide" element={<UserGuideDetails />} />
          <Route path="/releaseNote" element={<ReleaseNotes />} />
          <Route path="/releaseNoteHistory" element={<ReleaseNotesHistory />} />
          <Route path="/contact/*" element={<Contact />} />
          <Route path="/cir/*" element={<Cir />} />
          <Route path="/project/*" element={<Project />} />
          <Route path="/ProjectClosure/*" element={<ProjectClosure />} />
          <Route path="/ProjectMyPortfolio/*" element={<ProjectMyPortfolio />} />
          <Route path="/DLScoreCard/*" element={<DLScoreCard />} />
          <Route path="/DeliveryMetrics/*" element={<DeliveryMetrics />} />
          <Route path="/UploadCenter/*" element={<UploadCenter />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
